// extracted by mini-css-extract-plugin
var _1 = "FileIconThumbnail-modulefileIconThumbnail__kQFka Avatar-moduleavatar__cNFgJ";
var _2 = "FileIconThumbnail-modulesize100__SwP3I FileIconPlaceholder-modulesize100__SFdD2";
var _3 = "FileIconThumbnail-modulesize24__VcUF4 FileIconPlaceholder-modulesize24__Dioni";
var _4 = "FileIconThumbnail-modulesize32__IE44X FileIconPlaceholder-modulesize32__sFZ_C";
var _5 = "FileIconThumbnail-modulesize40__MQc1z FileIconPlaceholder-modulesize40__yHYjt";
var _6 = "FileIconThumbnail-modulesize44__F_Kiq FileIconPlaceholder-modulesize44__BMmJ2";
var _7 = "FileIconThumbnail-modulesize64__rnxoa FileIconPlaceholder-modulesize64__Qcqja";
export { _1 as "fileIconThumbnail", _2 as "size100", _3 as "size24", _4 as "size32", _5 as "size40", _6 as "size44", _7 as "size64" }
